import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { OrgMemberRole, TeamMemberRole } from '@makyoapp/makyo-sdk/models/ACL'
import { MemberAdapter } from '@makyoapp/makyo-common'
import { Field, Label, ModalGrid, SelectDropdown } from '@makyoapp/makyo-ui'

import { ORG_ROLE_OPTIONS, TEAM_ROLE_OPTIONS } from '@/shared/constants'

interface EditRoleModalProps {
  member: MemberAdapter
  isTeam: boolean
  onSubmit: (newRole: OrgMemberRole | TeamMemberRole) => void
  onHide: () => void
  show: boolean
}

export function EditRoleModal({ isTeam, member, onSubmit, onHide, show }: EditRoleModalProps) {
  const { t } = useTranslation()
  const [curRole, setRole] = useState(isTeam ? member.teamRole || TeamMemberRole.Viewer : member.orgRole)

  return (
    <ModalGrid
      show={show}
      onHide={onHide}
      title={t('Edit Role')}
      onConfirm={() => onSubmit(curRole)}
      onCancel={onHide}
      primaryTrailing={t('Update Role')}
    >
      <Field>
        <Label>{t('Role')}</Label>
        <SelectDropdown
          value={curRole}
          onChange={(opt) => {
            if (opt !== curRole) {
              setRole(opt)
            }
          }}
          renderOption={(opt) => t(opt)}
          options={!isTeam ? ORG_ROLE_OPTIONS : TEAM_ROLE_OPTIONS}
        />
      </Field>
    </ModalGrid>
  )
}
